/**
 * Check if Telegram WebApp version supports a specific feature
 * @param minVersion - Minimum required version (e.g., 6.1)
 * @returns true if current version is equal or higher than minVersion
 */
export const isTelegramVersionSupported = (minVersion: number): boolean => {
  const tg = window.Telegram?.WebApp
  if (!tg) return false

  const currentVersion = parseFloat(tg.version || '0')
  return currentVersion >= minVersion
}

export const useTelegram = () => {
  const tg = window.Telegram.WebApp

  return {
    tg,
    isTelegramVersionSupported,
  }
}
